import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import { createElement } from 'react'

import classnames from 'classnames'

import styles from './Accordion.module.scss'

export const Accordion: FunctionComponent<Props> = ({
  children,
  className,
  tag = 'div',
  ...rest
}) => {
  const props = {
    className: classnames(styles.accordion, className),
    'data-testid': 'accordion',
    ...rest,
  }

  return createElement(tag, props, children)
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Class name to be applied to the accordion itself
   */
  className?: string
  /**
   * Type of tag.
   */
  tag?: keyof JSX.IntrinsicElements
  children: ReactNode
} & HTMLProps<HTMLElement>
